import { setEvents } from 'redux/References/slice';
import { AppDispatch } from 'redux/store';
import { getFileNameFromContentDisposition } from 'utils/strActions';

export const CreateDownloadReferenceHandler = (
  id: string | undefined,
  dispatch: AppDispatch,
) => {
  return async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/docs/registration-reference/${id}/request`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      if (!response.ok) {
        if (response.status === 500) {
          throw new Error('500');
        } else {
          const dataMessage = await response.json();
          throw new Error(dataMessage.message);
        }
      }

      const disposition = response.headers.get('content-disposition');
      const blob = await response.blob();
      const fileName =
        getFileNameFromContentDisposition(disposition) || 'registration-reference.pdf';

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      const dataResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/docs/registration-reference/${id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );
      if (!dataResponse.ok) {
        throw new Error('Ошибка при запросе данных справки');
      }

      const data = await dataResponse.json();
      const events = Array.isArray(data) ? data : [data];
      dispatch(setEvents(events));
    } catch (error) {
      console.error('Ошибка запроса:', error);
      throw error;
    }
  };
};
